"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PriceImpactProductReport_1 = require("../model/PriceImpactProductReport");

var PriceImpactProductReportConverter_1 = require("./PriceImpactProductReportConverter");

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ImpactConverter_1 = require("./ImpactConverter");
/**
 * @author Michal Sevcenko
 */


var PriceImpactProductReportConverterImpl =
/*#__PURE__*/
function (_PriceImpactProductRe) {
  _inherits(PriceImpactProductReportConverterImpl, _PriceImpactProductRe);

  function PriceImpactProductReportConverterImpl(impactConverter) {
    var _this;

    _classCallCheck(this, PriceImpactProductReportConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceImpactProductReportConverterImpl).call(this));
    _this.impactConverter = impactConverter;
    return _this;
  }

  _createClass(PriceImpactProductReportConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new PriceImpactProductReport_1.PriceImpactProductReport(PriceImpactProductReport_1.PriceImpactProductReport.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), conversions.asObject(source, 'salesVolumeImpact', this.impactConverter.documentToObject(conversions)), conversions.asObject(source, 'marginImpact', this.impactConverter.documentToObject(conversions)), conversions.asObject(source, 'revenueImpact', this.impactConverter.documentToObject(conversions)), conversions.asObject(source, 'profitImpact', this.impactConverter.documentToObject(conversions)));
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        productId: conversions.toDocumentReferenceId(source.productId),
        salesVolumeImpact: this.impactConverter.toDocument(source.salesVolumeImpact, conversions),
        marginImpact: this.impactConverter.toDocument(source.marginImpact, conversions),
        revenueImpact: this.impactConverter.toDocument(source.revenueImpact, conversions),
        profitImpact: this.impactConverter.toDocument(source.profitImpact, conversions)
      };
    }
  }]);

  return PriceImpactProductReportConverterImpl;
}(PriceImpactProductReportConverter_1.PriceImpactProductReportConverter);

PriceImpactProductReportConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ImpactConverter_1.ImpactConverter])], PriceImpactProductReportConverterImpl);
exports.PriceImpactProductReportConverterImpl = PriceImpactProductReportConverterImpl;